@if(sectionlink && external){
  <a [href]="href | urlFixed" sps-button  [innerHTML]="label | hyphenate"></a>
}@else if (external) {
  <a [href]="href | urlFixed" sps-button [target]="linkTarget" [innerHTML]="label | hyphenate"></a>
} @else {
  <a [routerLink]="href" sps-button [innerHTML]="label | hyphenate"></a>
}


